import { Dispatch, SetStateAction } from 'react';
import { StrategyInfo } from '../../services/backtestApi';

interface BacktestFormProps {
  symbol: string;
  onSymbolChange: Dispatch<SetStateAction<string>>;
  strategy: string;
  onStrategyChange: Dispatch<SetStateAction<string>>;
  period: '3M' | '6M' | '1Y';
  onPeriodChange: Dispatch<SetStateAction<'3M' | '6M' | '1Y'>>;
  initialCapital: number;
  onInitialCapitalChange: Dispatch<SetStateAction<number>>;
  strategies: StrategyInfo[];
}

export default function BacktestForm(props: BacktestFormProps) {
  return (
    <div className="backtest-form">
      <TextInput label="종목" value={props.symbol} onChange={props.onSymbolChange} />
      <StrategySelect strategy={props.strategy} strategies={props.strategies} onChange={props.onStrategyChange} />
      <PeriodSelect period={props.period} onChange={props.onPeriodChange} />
      <CapitalInput value={props.initialCapital} onChange={props.onInitialCapitalChange} />
    </div>
  );
}

function TextInput({ label, value, onChange }: { label: string; value: string; onChange: Dispatch<SetStateAction<string>> }) {
  return <label>{label}<input type="text" value={value} onChange={(event) => onChange(event.target.value.toUpperCase())} placeholder="AAPL" /></label>;
}

function StrategySelect(props: { strategy: string; strategies: StrategyInfo[]; onChange: Dispatch<SetStateAction<string>> }) {
  return <label>전략<select value={props.strategy} onChange={(event) => props.onChange(event.target.value)}>{props.strategies.map((item) => <option key={item.code} value={item.code}>{item.name}</option>)}</select></label>;
}

function PeriodSelect(props: { period: '3M' | '6M' | '1Y'; onChange: Dispatch<SetStateAction<'3M' | '6M' | '1Y'>> }) {
  return <label>기간<select value={props.period} onChange={(event) => props.onChange(event.target.value as '3M' | '6M' | '1Y')}><option value="3M">3개월</option><option value="6M">6개월</option><option value="1Y">1년</option></select></label>;
}

function CapitalInput(props: { value: number; onChange: Dispatch<SetStateAction<number>> }) {
  return <label>초기 자본 (USD)<input type="number" value={props.value} onChange={(event) => props.onChange(Number(event.target.value))} placeholder="10000" min="1000" step="500" /></label>;
}
